import { render, staticRenderFns } from "./pageTitle.vue?vue&type=template&id=d8330540&scoped=true"
import script from "./pageTitle.vue?vue&type=script&lang=js"
export * from "./pageTitle.vue?vue&type=script&lang=js"
import style0 from "./pageTitle.vue?vue&type=style&index=0&id=d8330540&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8330540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8330540')) {
      api.createRecord('d8330540', component.options)
    } else {
      api.reload('d8330540', component.options)
    }
    module.hot.accept("./pageTitle.vue?vue&type=template&id=d8330540&scoped=true", function () {
      api.rerender('d8330540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/pageTitle.vue"
export default component.exports